import { SELECIONAR_CONEXAO } from '../types'

export default function selecionarConexao (conexao) {
  return {
    type: SELECIONAR_CONEXAO,
    payload: conexao
  }
}
